<script setup lang="ts">
import { ref } from "vue";
import { useWhatsNewStore } from "@/App/whatsNew/whatsNew.store";
import BaseModal from "@/App/components/BaseModal.vue";

const whatsNewStore = useWhatsNewStore();

const initialButtonLabel = "Remind Me Later";
const secondaryButtonLabel = "Okay";

const dontShowAgain = ref(false);
const cancelButtonLabel = ref(initialButtonLabel);

const showWhatsNew = (): void => {
  whatsNewStore.closeWhatsNew();
  whatsNewStore.preventWhatsNew();
};

const cancel = (): void => {
  whatsNewStore.closeWhatsNew();
  if (dontShowAgain.value) {
    whatsNewStore.preventWhatsNew();
  }
};

const onDontShowAgain = (): void => {
  if (dontShowAgain.value) {
    cancelButtonLabel.value = secondaryButtonLabel;
  } else {
    cancelButtonLabel.value = initialButtonLabel;
  }
};
</script>

<template>
  <BaseModal
    v-if="whatsNewStore.showWhatsNew"
    modal-id="whatsNew"
    wide
    no-okay
    button-label=""
    :cancel-button-label="cancelButtonLabel"
    modal-style="width: 250px;"
    @modal-cancel="cancel"
  >
    <div class="whats-new">
      <h4>Our Dashboard has some new features.</h4>
      <button
        class="btn btn-sm btn-outline-primary"
        aria-hidden="true"
        title="Options"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasDashboardWhatsNew"
        aria-controls="offcanvasDashboardWhatsNew"
        @click="showWhatsNew"
      >
        See What's New
      </button>
      <div class="dont">
        <input v-model="dontShowAgain" data-testid="show-refresh" type="checkbox" @change.stop="onDontShowAgain" />
        <span class="small-text">&nbsp; &nbsp;Don't show this again.</span>
      </div>
    </div>
  </BaseModal>
</template>
<style scoped>
h4 {
  text-align: center;
}
.whats-new {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.dont {
  margin-top: 1rem;
}
.small-text {
  font-size: 85%;
}
</style>
